export const PLATFORM_URL_PARAMETER = 'platform';
export const DELIMITER: string = ', ';
